var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cart-continer"},[_c('v-btn',{attrs:{"color":"primary"},on:{"click":_vm.addCarEvent}},[_vm._v("\n\t\tAñadir al carrito\n\t\t"),_c('v-icon',{staticClass:"ml-2",attrs:{"size":"20","color":"#ffff"}},[_vm._v("shopping_cart")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b3b74a54","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/icons/addcar-component.vue
// module id = 900
// module chunks = 0 1 5 6